module.exports = __webpack_public_path__ + "fa-light-300.d3aef04ff0c1bf731298.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-light-300.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-light-300.woff
// module chunks = styles